module.exports = __webpack_public_path__ + "img/search_none_product@2x.21b9e159.png";